import Agenda from './Agenda';
import { TipoBloqueioHorario } from '../enums/EnumTipoBloqueioHorario';

export default class BloqueioHorarioEspecifico {
    public id: number;

    public tenantId?: number;

    public agendaId: number;

    public agenda: Agenda;

    public tipoBloqueio: TipoBloqueioHorario;

    public data: string;

    public horarioInicio: string;

    public duracao: string;

    public descricao: string;

    constructor() {
      this.id = 0;
      this.tenantId = 0;
      this.agendaId = 0;
      this.agenda = new Agenda();
      this.tipoBloqueio = TipoBloqueioHorario.Almoco;
      this.data = '';
      this.horarioInicio = '';
      this.duracao = '';
      this.descricao = '';
    }
}

